export default "__VITE_ASSET__6b203eb8__"